import { BankAccountDetailPage } from '@/features/bank-account/pages/BankAccountDetailPage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/bank-account/$id/detail')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["bank_account.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: BankAccountDetailPage,
});
